import { z } from 'zod'

export const formSchema = z.object({
  // Agency Information
  companyName: z.string().min(2, 'Company name is required'),
  website: z.string().url('Please enter a valid website URL'),

  // Contact Information
  contactName: z.string().min(2, 'Contact name is required'),
  contactEmail: z.string().email('Please enter a valid email address'),
  contactPhone: z.string().optional(),

  // Agency Details
  companySize: z.string().min(1, 'Please select a company size'),
  yearsInBusiness: z.string().min(0, 'Please enter a valid number'),

  // Vendure Experience
  vendureExperience: z.string().min(1, 'Please enter your Vendure experience'),
  completedProjects: z.string().min(0, 'Please enter a valid number'),

  // Services Offered
  services: z.union([
    z.array(z.string()).min(1, 'Please select at least one service'),
    z
      .string()
      .min(1)
      .transform((str) =>
        str
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean),
      ),
  ]),

  // Geographic Information
  countriesServed: z.union([
    z.array(z.string()),
    z.string().transform((str) =>
      str
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean),
    ),
  ]),

  // Additional Information
  portfolioLinks: z.string().optional(),
  additionalInfo: z.string().optional(),

  // Agreement
  termsAgreed: z.union([
    z.boolean().refine((val) => val === true, {
      message: 'You must agree to the terms and conditions',
    }),
    z
      .string()
      .transform((val) => val === 'true')
      .refine((val) => val === true, {
        message: 'You must agree to the terms and conditions',
      }),
  ]),
})
